import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ToastEnum } from '../../enums/enum';
import { ToastService } from '../../services/toast.service';

interface IToast {
  id: number;
  type: ToastEnum;
  title: string;
  message: string | null;
  backgroundColor: string;
  borderColor: string;
  iconClass: string;
  iconColor: string;
  titleColor: string;
  bodyColor: string;
}

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
@UntilDestroy()
export class ToastComponent implements OnInit {
  public toasts: Array<IToast> = [];
  ToastEnum = ToastEnum;
  constructor(private readonly toastService: ToastService, private readonly transloco: TranslocoService) {}

  ngOnInit(): void {
    this.toastService.toasts$.pipe(untilDestroyed(this)).subscribe((toasts) => {
      this.toasts = toasts.map((toast) => {
        return this.getToastConfig(toast.type, toast.message, toast.id);
      });
    });
  }

  remove(id: number): void {
    this.toastService.remove(id);
  }

  getToastConfig(type: ToastEnum, message: string | null, id: number): IToast {
    switch (type) {
      case ToastEnum.success:
        return {
          id,
          type: ToastEnum.success,
          title: this.transloco.translate('success'),
          message: this.transloco.translate(`${message}`),
          backgroundColor: '#d4edda',
          borderColor: '#c3e6cb',
          iconClass: 'bi-check-circle',
          iconColor: 'green',
          titleColor: '#155724',
          bodyColor: '#155724',
        };
      case ToastEnum.error:
        return {
          id,
          type: ToastEnum.error,
          title: this.transloco.translate('error.title'),
          message: this.transloco.translate(`${message}`),
          backgroundColor: '#f8d7da',
          borderColor: '#f5c6cb',
          iconClass: 'bi-exclamation-circle',
          iconColor: 'red',
          titleColor: '#721c24',
          bodyColor: '#721c24',
        };
      case ToastEnum.warning:
        return {
          id,
          type: ToastEnum.warning,
          title: this.transloco.translate('warning'),
          message: this.transloco.translate(`${message}`),
          backgroundColor: '#fff3cd',
          borderColor: '#ffeeba',
          iconClass: 'bi-exclamation-triangle',
          iconColor: 'orange',
          titleColor: '#856404',
          bodyColor: '#856404',
        };
      case ToastEnum.info:
        return {
          id,
          type: ToastEnum.info,
          title: this.transloco.translate('info'),
          message: this.transloco.translate(`${message}`),
          backgroundColor: '#d1ecf1',
          borderColor: '#bee5eb',
          iconClass: 'bi-info-circle',
          iconColor: 'blue',
          titleColor: '#0c5460',
          bodyColor: '#0c5460',
        };
    }
  }
}
